import Application from "../../Application";
import OrganisationAttachmentTypePage from "../ui/pages/OrganisationAttachmentTypePage";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import AddCaseLawDocumentTypeToOrganisationInteractor from "../interactors/AddCaseLawDocumentTypeToOrganisationInteractor";
import GetCaseLawDocumentTypesForOrganisationInteractor from "../interactors/GetCaseLawDocumentTypesForOrganisationInteractor";
import GetInstitutionDetailsInteractor from "../interactors/GetOrganisationInstitutionDetailsInteractor";
import GetOrganisationInteractor from "../interactors/GetOrganisationInteractor";
import ShowOrganisationDetailsCaseLawDocumentTypesInteractor from "../interactors/ShowOrganisationDetailsCaseLawDocumentTypeInteractor";
import ShowOrganisationDetailsInteractor from "../interactors/ShowOrganisationDetailsInteractor";
import ShowOrganisationsInteractor from "../interactors/ShowOrganisationsInteractor";
import OrganisationCaseLawDocumentTypePage from "../ui/pages/OrganisationCaseLawDocumentTypePage";
import OrganisationDetailsPage from "../ui/pages/OrganisationDetailsPage";
import OrganisationPage from "../ui/pages/OrganisationsPage";
import CreateAttachmentTypeInteractor from "../../attachmentType/interactor/CreateAttachmentTypeInteractor";
import UpdateAttachmentTypeInteractor from "../../attachmentType/interactor/UpdateAttachmentTypeInteractor";
import GetAllCaseLawDocumentAttachmentTypesInteractor from "../../caseLawDocuments/interactor/attachments/GetAllCaseLawDocumentAttachmentTypesInteractor";
import AddCaseLawDocumentTypeIndexCategoriesInteractor from "../interactors/AddCaseLawDocumentTypeIndexCategoriesInteractor";
import CreateOrganisationInteractor from "../interactors/CreateOrganisationInteractor";
import GetAllOrganisationsInteractor from "../interactors/GetAllOrganisationsInteractor";
import GetAllRegistryInstitutionsInteractor from "../interactors/GetAllRegistryInstitutionsInteractor";
import ShowOrganisationDetailsHomeInteractor from "../interactors/ShowOrganisationDetailsHomeInteractor";
import OrganisationDetailsHomePage from "../ui/pages/OrganisationDetailsHomePage";
import GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor from "../interactors/GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor";
import GetCaseLawDocumentTypeIndexCategoriesInteractor from "../interactors/GetCaseLawDocumentTypeOrganisationIndexCategoriesInteractor";
import GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor from "../interactors/GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor";
import FindIndexesInCategoryForOrganisationInteractor from "../interactors/FindIndexesInCategoryForOrganisationInteractor";
import GetAllOrganisationAttachmentTypesInteractor from "../interactors/GetAllOrganisationAttachmentTypesInteractor";
import ShowOrganisationAttachmentTypesInteractor from "../interactors/ShowOrganisationAttachmentTypeInteractor";
import UpdateOrganisationInteractor from "../interactors/UpdateOrganisationInteractor";
import ImportOrganisationDescriptorsInteractor from "../interactors/ImportOrganisationDescriptorsInteractor";
import FindConnectionCandidatesForIndexInteractor from "../interactors/FindConnectionCandidatesForIndexInteractor";
import FindConnectionCandidatesForGroupInteractor from "../interactors/FindConnectionCandidatesForGroupInteractor";
import ConnectIndexesInteractor from "../interactors/ConnectIndexesInteractor";
import FindConnectedIndexesInteractor from "../interactors/FindConnectedIndexesInteractor";
import GetOrganisationIndexTreeInteractor from "../interactors/GetOrganisationIndexTreeInteractor";
import AddCaseLawDocumentTypeVisibilityLevelsInteractor from "../interactors/AddCaseLawDocumentTypeVisibilityLevelsInteractor";
import GetCaseLawDocumentTypeVisibilityLevelsInteractor from "../interactors/GetCaseLawDocumentTypeVisibilityLevelsInteractor";
import RemoveDocumentCaseLawDocumentTypeInteractor from "../interactors/RemoveDocumentCaseLawDocumentTypeInteractor";
import UpdateOrganisationIndexInteractor from "../interactors/UpdateOrganisationIndexInteractor";
import UpdateOrganisationIndexGroupInteractor from "../interactors/UpdateOrganisationIndexGroupInteractor";
import ImportAllOrganisationCategoriesInteractor from "../interactors/ImportAllOrganisationCategoriesInteractor";
import GetAllOrganisationIndexGroupsInteractor from "../interactors/GetAllOrganisationIndexGroupsInteractor";
import ConnectIndexGroupsInteractor from "../interactors/ConnectIndexGroupsInteractor";
import FindConnectedIndexGroupsInteractor from "../interactors/FindConnectedIndexGroupsInteractor";
import GetCaseLawDocumentsByIndexInteractor from "../interactors/GetCaseLawDocumentsByIndexInteractor";
import RemoveOrganisationIndexInteractor from "../interactors/RemoveOrganisationIndexInteractor";
import FindSwitchGroupCandidatesForIndexInteractor from "../interactors/FindSwitchGroupCandidatesForIndexInteractor";
import SwitchGroupForOrganisationIndexInteractor from "../interactors/SwitchGroupForOrganisationIndexInteractor";
import RemoveOrganisationIndexGroupInteractor from "../interactors/RemoveOrganisationIndexGroupInteractor";
import GetHarmonizedIndexTreeInteractor from "../interactors/GetHarmonizedIndexTreeInteractor";
import GetConnectionCandidatesByCategoryInteractor from "../interactors/GetConnectionCandidatesByCategoryInteractor";
import ConnectIndexesByCategoryInteractor from "../interactors/ConnectIndexesByCategoryInteractor";
import GetConnectedIndexesByCategoryInteractor from "../interactors/GetConnectedIndexesByCategoryInteractor";
import GetIndexCategoriesForAllOrganisationsInteractor from "../interactors/GetIndexCategoriesForAllOrganisationsInteractor";

export default class OrganisationArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }

  private registerModules() {
    const container = this.application.container;
    container.registerInteractor(
      "addCaseLawDocumentTypeToOrganisation",
      AddCaseLawDocumentTypeToOrganisationInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentTypesForOrganisation",
      GetCaseLawDocumentTypesForOrganisationInteractor
    );
    container.registerInteractor(
      "showOrganisationDetails",
      ShowOrganisationDetailsInteractor
    );
    container.registerInteractor(
      "showOrganisationDetailsCaseLawDocumentTypes",
      ShowOrganisationDetailsCaseLawDocumentTypesInteractor
    );
    container.registerInteractor(
      "getInstitutionDetails",
      GetInstitutionDetailsInteractor
    );
    container.registerInteractor(
      "createAttachmentType",
      CreateAttachmentTypeInteractor
    );
    container.registerInteractor(
      "updateAttachmentType",
      UpdateAttachmentTypeInteractor
    );
    container.registerInteractor(
      "getAllOrganisationAttachmentTypes",
      GetAllOrganisationAttachmentTypesInteractor
    );
    container.registerInteractor(
      "showOrganisationAttachmentTypes",
      ShowOrganisationAttachmentTypesInteractor
    );
    container.registerInteractor(
      "getAllCaseLawDocumentAttachmentTypes",
      GetAllCaseLawDocumentAttachmentTypesInteractor
    );
    container.registerInteractor(
      "addCaseLawDocumentTypeIndexCategories",
      AddCaseLawDocumentTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "showOrganisations",
      ShowOrganisationsInteractor
    );
    container.registerInteractor(
      "getAllOrganisations",
      GetAllOrganisationsInteractor
    );
    container.registerInteractor(
      "createOrganisation",
      CreateOrganisationInteractor
    );
    container.registerInteractor(
      "getAllRegistryInstitutions",
      GetAllRegistryInstitutionsInteractor
    );
    container.registerInteractor("getOrganisation", GetOrganisationInteractor);
    container.registerInteractor(
      "showOrganisationDetailsHome",
      ShowOrganisationDetailsHomeInteractor
    );
    container.registerInteractor(
      "getAllOrganisationCaseLawDocumentsWithCategories",
      GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentTypeIndexCategories",
      GetCaseLawDocumentTypeIndexCategoriesInteractor
    );
    container.registerInteractor(
      "getAllOrganisationCaseDecisionTypesWithCategories",
      GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor
    );
    container.registerInteractor(
      "findIndexesInCategoryForOrganisation",
      FindIndexesInCategoryForOrganisationInteractor
    );
    container.registerInteractor(
      "updateOrganisation",
      UpdateOrganisationInteractor
    );
    container.registerInteractor(
      "importOrganisationDescriptors",
      ImportOrganisationDescriptorsInteractor
    );
    container.registerInteractor(
      "importAllOrganisationCategories",
      ImportAllOrganisationCategoriesInteractor
    );
    container.registerInteractor(
      "findConnectionCandidatesForIndex",
      FindConnectionCandidatesForIndexInteractor
    );
    container.registerInteractor(
      "findConnectionCandidatesForGroup",
      FindConnectionCandidatesForGroupInteractor
    );
    container.registerInteractor("connectIndexes", ConnectIndexesInteractor);
    container.registerInteractor(
      "findConnectedIndexes",
      FindConnectedIndexesInteractor
    );

    container.registerInteractor(
      "getOrganisationIndexTree",
      GetOrganisationIndexTreeInteractor
    );
    container.registerInteractor(
      "getHarmonizedIndexTree",
      GetHarmonizedIndexTreeInteractor
    );
    container.registerInteractor(
      "addCaseLawDocumentTypeVisibilityLevels",
      AddCaseLawDocumentTypeVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentTypeVisibilityLevels",
      GetCaseLawDocumentTypeVisibilityLevelsInteractor
    );
    container.registerInteractor(
      "removeDocumentCaseLawDocumentType",
      RemoveDocumentCaseLawDocumentTypeInteractor
    );
    container.registerInteractor(
      "updateOrganisationIndex",
      UpdateOrganisationIndexInteractor
    );
    container.registerInteractor(
      "updateOrganisationIndexGroup",
      UpdateOrganisationIndexGroupInteractor
    );
    container.registerInteractor(
      "getAllOrganisationIndexGroups",
      GetAllOrganisationIndexGroupsInteractor
    );
    container.registerInteractor(
      "connectIndexGroups",
      ConnectIndexGroupsInteractor
    );
    container.registerInteractor(
      "findConnectedIndexGroups",
      FindConnectedIndexGroupsInteractor
    );
    container.registerInteractor(
      "getCaseLawDocumentsByIndex",
      GetCaseLawDocumentsByIndexInteractor
    );
    container.registerInteractor(
      "removeOrganisationIndex",
      RemoveOrganisationIndexInteractor
    );
    container.registerInteractor(
      "findSwitchGroupCandidatesForIndex",
      FindSwitchGroupCandidatesForIndexInteractor
    );
    container.registerInteractor(
      "switchGroupForOrganisationIndex",
      SwitchGroupForOrganisationIndexInteractor
    );
    container.registerInteractor(
      "removeOrganisationIndexGroup",
      RemoveOrganisationIndexGroupInteractor
    );
    container.registerInteractor(
      "GetConnectionCandidatesByCategory",
      GetConnectionCandidatesByCategoryInteractor
    );
    container.registerInteractor(
      "connectIndexesByCategory",
      ConnectIndexesByCategoryInteractor
    );
    container.registerInteractor(
      "getConnectedIndexesByCategory",
      GetConnectedIndexesByCategoryInteractor
    );
    container.registerInteractor(
      "getIndexCategoriesForAllOrganisations",
      GetIndexCategoriesForAllOrganisationsInteractor
    );
  }
  register(params: any) {
    this.registerModules();

    this.router.registerRoutes(
      {
        path: "/organisations",
        page: this.createPage({
          Page: OrganisationPage,
          action: this.showOrganisationsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/organisations/:id",
        page: this.createPage({
          Page: OrganisationDetailsPage,
          action: this.showOrganisationDetailsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/organisations/:id/attachment-type",
        page: this.createPage({
          Page: OrganisationAttachmentTypePage,
          action: this.showOrganisationAttachmentTypes.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/organisation/:id",
        page: this.createPage({
          Page: OrganisationDetailsHomePage,
          action: this.showOrganisationDetailsHomePage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/organisations/:id/case-law-document-type",
        page: this.createPage({
          Page: OrganisationCaseLawDocumentTypePage,
          action: this.showOrganisationCaseLawDocumentTypes.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showOrganisationDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationDetailsInteractor>("showOrganisationDetails")
      .execute(Number.parseInt(id, 10));
  }
  public showOrganisationDetailsHomePage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationDetailsHomeInteractor>(
        "showOrganisationDetailsHome"
      )
      .execute(Number.parseInt(id, 10));
  }
  public showOrganisationAttachmentTypes({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationAttachmentTypesInteractor>(
        "showOrganisationAttachmentTypes"
      )
      .execute(Number.parseInt(id, 10));
  }
  public showOrganisationCaseLawDocumentTypes({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowOrganisationDetailsCaseLawDocumentTypesInteractor>(
        "showOrganisationDetailsCaseLawDocumentTypes"
      )
      .execute(Number.parseInt(id, 10));
  }
  public showOrganisationsPage() {
    return this.application.container
      .resolve<ShowOrganisationsInteractor>("showOrganisations")
      .execute();
  }
}
